export default class CustomError extends Error {
    statusCode: number;

    constructor(message: string, statusCode = 500) {
        super(message);
        this.name = new.target.name;
        this.statusCode = statusCode;
        Error.captureStackTrace(this, this.constructor);
    }
}